/**
 * Marks of the ad that brought the visitor, kept from the first page of the visit: by the time the form is sent the
 * address may have lost them.
 */
const KEY = 'lead_utm';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const rememberUtm = () => {
    try {
        if (sessionStorage.getItem(KEY) !== null) {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const utm: Record<string, string> = {};

        for (const key of UTM_KEYS) {
            const value = params.get(key);

            if (value) {
                utm[key] = value.slice(0, 255);
            }
        }

        if (document.referrer && !document.referrer.startsWith(window.location.origin)) {
            utm.referrer = document.referrer.slice(0, 255);
        }

        sessionStorage.setItem(KEY, JSON.stringify(utm));
    } catch {
        // Storage may be off: the request goes without marks.
    }
};

export const readUtm = (): Record<string, string> | null => {
    try {
        const utm = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as Record<string, string> | null;

        return utm && Object.keys(utm).length ? utm : null;
    } catch {
        return null;
    }
};
